const MEDIA_QUERY = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)'

module.exports = () => {
  if (window.devicePixelRatio > 1) return true

  if (window.matchMedia && window.matchMedia(MEDIA_QUERY).matches) return true

  return false
}
